// extracted by mini-css-extract-plugin
export var highlightFade = "_38-4";
export var highlighted = "_38-3";
export var table = "_38-1";
export var tableContainer = "_38-0";
export var totalsRow = "_38-2";